export default __webpack_public_path__ + "static/media/HE.cc84b51e.jpeg";